import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { useQueryClient } from '@tanstack/react-query'
import * as Sc from './ModalSchoolCodeStudent.style'
import { getSchool } from 'api/user'
import { IconInfo } from 'assets/icons/IconInfo'
import Button from 'components/Button'
import InputText from 'components/InputText'
import Modal from 'components/ModalDeprecated'
import { hideLoader } from 'store/actions/drawer.actions'
import { TYPES_USER_ROLES } from 'utils/constants'
import { USER_KEYS } from 'hooks/user'

const ModalSchoolCodeStudent = ({ closeModal, onSubmit }) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const [schoolCode, setCodeSchool] = useState('')
  const [formCodeCenter, setFormCodeCenter] = useState({
    disabled: true,
    isValid: null,
    loading: false,
    message: null,
  })
  const dispatch = useDispatch()
  const { name: nameStudentRelative } = useSelector(
    ({ students }) => students?.newStudent || ''
  )
  const {
    name: nameStudent,
    role,
    userFlags,
  } = queryClient.getQueryData({
    queryKey: [USER_KEYS.GET_USER],
  })
  const isFirstSteps = userFlags?.FIRST_STEPS === 'true'
  const maxLengthCodeSchool = 7
  const timeDebounce = 500
  const tooltip = {
    icon: <IconInfo />,
    text: (
      <Trans
        i18nKey={
          'El código de centro es un número de 6 cifras que necesitas para formar parte del centro, de las clases y acceder a los libros'
        }
      >
        El código de centro es un número de 6 cifras que necesitas para formar
        parte del centro, de las clases y acceder a los libros. Si no dispones
        de un código ponte en contacto con tu profesor/a.
      </Trans>
    ),
  }

  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (schoolCode) {
        dispatch(hideLoader(true))
        setFormCodeCenter({
          ...formCodeCenter,
          loading: true,
        })
        let newMessage = null
        let newValid = null
        let newDisabled = false
        await getSchool(schoolCode)
          .then(({ name }) => {
            newMessage = t(
              'Este código pertenece al centro {{name}} Si es correcto continua el proceso',
              { name }
            )
            newValid = true
          })
          .catch(() => {
            newMessage = t(
              'Este código no esta asociado a ningún centro de nuestra base de datos Vuelve a introducir el código'
            )
            newValid = false
            newDisabled = true
          })
        setFormCodeCenter({
          ...formCodeCenter,
          disabled: newDisabled,
          isValid: newValid,
          loading: false,
          message: newMessage,
        })
        dispatch(hideLoader(false))
      } else {
        setFormCodeCenter({
          ...formCodeCenter,
          disabled: true,
          isValid: null,
          message: null,
        })
      }
    }, timeDebounce)

    return () => clearTimeout(timeout)
  }, [schoolCode])

  return (
    <Modal open>
      <Sc.Container>
        <Sc.Wrapper>
          {isFirstSteps ? (
            <>
              <Sc.NewTitle>
                {t('Bienvenido/a a Edubook, {{name}}', { name: nameStudent })}
              </Sc.NewTitle>
              <Sc.SubTitle>
                {t('Indica el código de tu centro educativo')}
              </Sc.SubTitle>
            </>
          ) : (
            <>
              <Sc.NewTitle>
                {role === TYPES_USER_ROLES.RELATIVE
                  ? t('Indica el código del centro educativo de {{name}}', {
                      name: nameStudentRelative,
                    })
                  : t('Indica el código de tu centro educativo')}
              </Sc.NewTitle>
              <Sc.SubTitle>
                {t(
                  'Si todavía no tienes el código de tu centro educativo, pídeselo a tu profesor/a'
                )}
              </Sc.SubTitle>
            </>
          )}
          <Sc.Form>
            <InputText
              id='schoolCode'
              isValid={formCodeCenter.isValid}
              maxLength={maxLengthCodeSchool}
              onChange={({ target: { value } }) => setCodeSchool(value.trim())}
              placeholder={t('Escribe aquí el código de centro')}
              showLoader={formCodeCenter.loading}
              tooltip={tooltip}
              value={schoolCode}
            />
            {formCodeCenter.message && (
              <Sc.Message isValid={formCodeCenter.isValid}>
                {formCodeCenter.message}
              </Sc.Message>
            )}
          </Sc.Form>
          <Sc.BoxButtons>
            <Button classes={{ second: true }} onPress={() => closeModal()}>
              {t('No unirme a ninguna clase')}
            </Button>
            <Button
              disabled={formCodeCenter.disabled}
              onPress={() => onSubmit(schoolCode)}
            >
              {t('Siguiente')}
            </Button>
          </Sc.BoxButtons>
        </Sc.Wrapper>
      </Sc.Container>
    </Modal>
  )
}

ModalSchoolCodeStudent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ModalSchoolCodeStudent
